import {
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from 'recharts';
import { useState } from 'react';

import { type Metric, type MetricLog } from '@/database/types';
import { aggregateMetricLogs } from '../utils/aggregation';

export default function CompositeGraph() {
  const [templates, setTemplates] = useState<Metric[]>([]);
  const [logs, setLogs] = useState<MetricLog[]>([]);

  const chartData = templates.map((template) => {
    const data = aggregateMetricLogs(
      logs,
      template,
      new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
      new Date()
    );
    return { template, data };
  });

  const customTooltipStyles = {
    background: 'rgba(249, 246, 240, 0.95)',
    border: '1px solid rgba(26, 34, 56, 0.16)',
    borderRadius: 14,
    color: 'var(--liturgy-ink)',
    boxShadow: '0 16px 32px rgba(26, 34, 56, 0.12)',
  }; /* todo: revisit these for sure. */

  return (
    <ResponsiveContainer>
      <BarChart data={chartData}>
        <CartesianGrid stroke="rgba(26,34,56,0.08)" vertical={false} />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 12, fill: 'var(--liturgy-ink)' }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip contentStyle={customTooltipStyles} />
        <Bar
          dataKey="value"
          radius={[8, 8, 0, 0]}
          fill="var(--sage-mist)"
          stroke="rgba(26,34,56,0.12)"
          strokeWidth={1}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
